import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { api } from '../../services/api';
import { useInvalidatingMutation } from '../utils/mutation';

export interface BatchUser {
  id: string;
  name: string;
}

export interface Batch {
  id: string;
  name: string;
  numReviewed: number;
  numNotReviewed: number;
  totalItems: number;
  users: BatchUser[];
  roles: { name: string }[];
  status: string | null;
}

export interface BatchPage {
  totalBatches: number;
  totalItems: number;
  totalReviewed: number;
  totalNotReviewed: number;
  batches: Batch[];
}

export function useProjectBatches(projectId: string, page: number, limit: number, assignedOnly: boolean = false) {
  return useQuery<BatchPage>({
    queryKey: ['batches', projectId, page, limit, assignedOnly],
    queryFn: () => api.get<BatchPage>(`/project/${projectId}/batch?page=${page}&limit=${limit}&assignedOnly=${assignedOnly}`),
    enabled: !!projectId,
    // Keep the current page's batches (and the pagination controls) mounted
    // while the next page loads instead of collapsing the grid between fetches.
    placeholderData: keepPreviousData,
  });
}

export interface AssignBatchInput {
  id: string;
  keepFamiliesTogether: boolean;
  delimiter: string;
  startValue: number;
  zeroPaddingLength: number;
  filesPerBatch: number;
  users: BatchUser[];
  roles: object[];
}

export function useAssignBatch(projectId: string) {
  return useInvalidatingMutation<unknown, AssignBatchInput>(
    ['batches', projectId],
    (input) => api.post(`/project/${projectId}/batch/assign`, input),
  );
}
